module.exports = __webpack_public_path__ + "static/media/utu_dark.6e019ae4.svg";